import React from "react";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useState } from "react";
import Modal from "react-modal";
import { Button } from "reactstrap";
import AlertComponent from "../alert/AlertComponent";
import "./ModalComponent.scss";
import AddDataset from "../../views/project/data/AddDataset";
import getDataFromApi from "../getDataFromApi";
Modal.setAppElement("body");
export const alertContext = React.createContext();

const CENTERED_MODAL_STYLE = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(15, 23, 42, 0.55)",
    zIndex: 1000,
  },
  content: {
    position: "absolute",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    margin: "0",
    width: "min(520px, 94vw)",
    maxWidth: "520px",
    maxHeight: "90vh",
    overflow: "auto",
    border: "none",
    borderRadius: "18px",
    padding: "1.25rem",
    background: "var(--bg-color, #fff)",
  },
};

export default function ModalComponent({
  modalIsOpen,
  setModalIsOpen,
  modalClass,
  overlayClassName = "",
  component,
  newdatasetId
}) {
  const isModalOpen =
    typeof modalIsOpen === "boolean"
      ? modalIsOpen
      : typeof modalIsOpen === "string"
      ? modalIsOpen.length > 0
      : Boolean(modalIsOpen);

  const isCenteredOverlay = Boolean(
    overlayClassName &&
      String(overlayClassName).includes("tracking-start-modal-overlay")
  );

  const closeModal = () => {
    if (component?.type === AddDataset && newdatasetId) {
      const url = `${window["ENV"].API_URL}/datasets/${newdatasetId}?confirm=`+true;
      getDataFromApi(url, "delete")
        .then((r) => {
          console.log(r);
        })
        .catch((e) => {
          console.log(e);
          if (e.message.includes("unauthorised")) {
            setAlert({ message: "🚫 You are not authorised to delete.", status: "error" });
          }
        });
    }

    if (typeof modalIsOpen === "boolean") {
      setModalIsOpen(false);
      return;
    }

    setModalIsOpen("");
  };
  const [alert, setAlert] = useState();

  return (
    <div>
      <AlertComponent alert={alert} />
      <Modal
        className={`ReactModal__Content responsive-modal ${modalClass || ""}`}
        overlayClassName={`ReactModal__Overlay ReactModal__Overlay--after-open ${overlayClassName || ""}`}
        isOpen={isModalOpen}
        contentLabel="Example Modal"
        style={isCenteredOverlay ? CENTERED_MODAL_STYLE : undefined}
      >
        <Button
          className="float-right"
          color="transparant"
          onClick={() => {
            closeModal();
          }}
          style={{
            position: "sticky",
            zIndex: 9999,
            top: 0,
            marginRight: "-8px",
          }}
        >
          <FontAwesomeIcon
            icon={faTimes}
            color="grey"
            size="lg"
          ></FontAwesomeIcon>
        </Button>
        <alertContext.Provider value={setAlert}>
          {component}
        </alertContext.Provider>
      </Modal>
    </div>
  );
}
